import { useState } from "react";
import { Loader2 } from "lucide-react";
import { FormModal } from "./form";
import { OutlineButton, PrimaryButton } from "./Buttons";
import CustomSelect from "./CustomSelect";

/**
 * Pick a single property configuration to assign. Parent owns the configs
 * list and the assign callback. Not a multi-field form — just a single
 * dropdown — so we use the canonical CustomSelect directly rather than
 * spinning up a Form context.
 */
function ConfigAssignmentModal({ open, onClose, propertyConfigs, onAssign, configAssignmentLoading }) {
    const [selectedConfig, setSelectedConfig] = useState(null);

    // Defensive: callers historically passed either a plain array OR a
    // paginated response wrapper ({items: [...], total: N}). The pre-refactor
    // code crashed on the wrapper shape too — this normalizes both so the
    // crash can't recur regardless of what the parent decides to send.
    const rawConfigs = Array.isArray(propertyConfigs)
        ? propertyConfigs
        : Array.isArray(propertyConfigs?.items)
            ? propertyConfigs.items
            : [];
    const validOptions = rawConfigs
        .filter((c) => c && c.propertyConfigId)
        .map((c) => ({
            value: c.propertyConfigId,
            label: `${c.propertyType} - ${c.configName}`,
        }));

    const selectedOption = validOptions.find((o) => o.value === selectedConfig) || null;

    return (
        <FormModal
            open={open}
            onClose={onClose}
            title="Assign Property Configuration"
            size="sm"
            footer={
                <div className="flex justify-end gap-2">
                    <OutlineButton onClick={onClose}>Cancel</OutlineButton>
                    <PrimaryButton
                        onClick={() => onAssign(selectedConfig)}
                        disabled={!selectedConfig || configAssignmentLoading}
                    >
                        {configAssignmentLoading ? (
                            <Loader2 className="animate-spin mr-2" size={16} />
                        ) : (
                            "Assign"
                        )}
                    </PrimaryButton>
                </div>
            }
        >
            <CustomSelect
                label="Select Configuration"
                required
                placeholder="Select a configuration"
                options={validOptions}
                value={selectedOption}
                onChange={(opt) => setSelectedConfig(opt?.value ?? null)}
                styles={{}}
                menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
                menuPosition="fixed"
                menuPlacement="auto"
                size="form"
            />
        </FormModal>
    );
}

export default ConfigAssignmentModal;
